import type { ReactNode } from "react";
import { FormControl, FormLabel, Text, useColorModeValue } from "@chakra-ui/react";
import type { FieldValue, FormField } from "../types";

export type FieldOnChange = (
  fieldId: number,
  value: string | null,
  valueOptions?: string[] | null
) => void;

export type FieldUploadFn = (
  fieldId: number,
  file: File
) => Promise<{ download_url: string; file_name: string }>;

export interface FieldControlProps {
  field: FormField;
  fieldValue: FieldValue | undefined;
  onChange: FieldOnChange;
  onUploadFile: FieldUploadFn;
  showError: boolean;
  errMsg?: string;
}

/** Wrapper comum: FormControl + label + mensagem de erro. Evita repetição entre os tipos. */
export function FieldShell({
  field,
  showError,
  errMsg,
  children,
}: {
  field: FormField;
  showError: boolean;
  errMsg?: string;
  children: ReactNode;
}) {
  const labelColor = useColorModeValue("#434347", "#e8edf2");
  return (
    <FormControl isRequired={field.is_required}>
      <FormLabel fontSize="sm" fontWeight={600} color={labelColor} mb={1.5}>
        {field.label}
      </FormLabel>
      {children}
      {showError && <Text color="red.500" fontSize="xs" mt={1}>{errMsg}</Text>}
    </FormControl>
  );
}